import React, { PropTypes } from 'react';
import { AuthorizedComponent } from 'react-router-role-authorization';
import { connect } from 'react-redux';
import { withRouter, Link, browserHistory } from 'react-router';
import { CSVLink } from 'react-csv';
import _ from 'lodash';

import CardBlock from "../components/bootstrap/CardBlock";
import NavBar from "../components/NavBar";
import NavLink from "../components/NavLink";
import { INSTRUCTOR, STUDENT } from '../constants/roles';
import Spinner from "react-spinkit";
import {
    ASSIGNMENTS__REQUESTED,
    DROPBOXES__REQUESTED,
    DROPBOX__USERS__REQUESTED,
    DROPBOXES__ROLES__REQUESTED,
    ROLES__SELF__REQUESTED,
    ASSIGNMENT__MEMBERSHIPS__REQUESTED,
    ASSIGNMENT__SUBMISSIONS__REQUESTED
} from "../constants/actionTypes";
import {getMappedKeyEntities, spaceToUnderscore} from "../helpers/helpers";

class InstructorAssignmentGroupsPage extends AuthorizedComponent {

    constructor(props) {
        super(props);

        this.userRoles = props.auth.roles;
        this.notAuthorizedPath = '/not-found';

        this.state = {
            group_search : ""
        };

        this.handleGroupSearchChange = this.handleGroupSearchChange.bind(this);
    }

    componentDidMount() {
        const { dispatch } = this.props;

        dispatch({
            type: ROLES__SELF__REQUESTED
        });
    }

    componentDidUpdate(prevProps) {
        const { assignments, dispatch, dropboxes, memberships, roles_self, submissions, users } = this.props;

        if (prevProps.roles_self !== roles_self) {
            dispatch({
                type: DROPBOXES__REQUESTED,
            });
        }

        if (prevProps.dropboxes !== dropboxes) {
            if (this.hasInstructorRole()) {
                dispatch({
                    type: ASSIGNMENTS__REQUESTED,
                });

                if (prevProps.dropboxes !== dropboxes) {
                    const dropbox = this.getDropbox(),
                        dropboxId = dropbox.id
                    ;

                    if (users.dropbox !== dropboxId) {
                        dispatch({
                            type: DROPBOXES__ROLES__REQUESTED,
                            payload: { dropboxId }
                        });

                        dispatch({
                            type: DROPBOX__USERS__REQUESTED,
                            payload: { dropboxId },
                        });
                    }
                }
            } else {
                browserHistory.push('/not-found');
            }
        }

        if (prevProps.assignments !== assignments) {
            if (this.hasInstructorRole()) {
                const assignment = this.getAssignment(),
                    assignmentId = assignment.id
                ;

                if (memberships.assignment !== assignmentId) {
                    dispatch({
                        type: ASSIGNMENT__MEMBERSHIPS__REQUESTED,
                        payload: { assignmentId },
                    });
                }

                if (submissions.assignment !== assignmentId) {
                    dispatch({
                        type: ASSIGNMENT__SUBMISSIONS__REQUESTED,
                        payload: { assignmentId },
                    });
                }
            } else {
                browserHistory.push('/not-found');
            }
        }
    }

    getDropbox() {
        const { dropboxes, params } = this.props;

        return _.last(
            _.filter (dropboxes, dropbox => {
                return dropbox.name === params.dropboxName;
            })
        );
    }

    getAssignment() {
        const { assignments, params } = this.props,
            { assignmentName, dropboxName } = params
        ;

        return _.last(
            _.filter (
                assignments,
                assignment => {
                    return spaceToUnderscore(assignment.name) === assignmentName
                        && assignment.dropbox.name === dropboxName
                    ;
                }
            )
        );
    }

    hasInstructorRole() {
        const { params, roles_self } = this.props;
        return _.includes(
            _.flatMap(
                roles_self,
                dropbox_role => {
                    if (dropbox_role.dropbox.name === params.dropboxName) {
                        return dropbox_role.role;
                    }
                }),
            INSTRUCTOR
        );
    }

    handleGroupSearchChange(event){
        this.setState({
            group_search: (event.target.value)
        });
    }

    renderSubmissions() {
        const { group_search } = this.state,
            { roles } = this.props,
            assignment = this.getAssignment(),
            memberships = getMappedKeyEntities(this.props.memberships),
            submissions = getMappedKeyEntities(this.props.submissions, 'id', 'string'),
            users = getMappedKeyEntities(this.props.users)
        ;

        return _.size(users) > 0
        ?
            _.map(
                _.filter(
                    submissions,
                    submission => {
                        return _.filter(
                            _.filter(
                                memberships,
                                membership => {
                                    return membership.submission.id === submission.id;
                                }
                            ),
                            membership => {
                                const user = users[membership.user.id],
                                    { username, first_name, last_name } = user
                                ;

                                let precept = _.find(
                                    _.map(
                                        _.filter(
                                            roles,
                                            dropbox_role => {
                                                return dropbox_role.role === STUDENT
                                                    && dropbox_role.user.id === user.id
                                                ;
                                            }
                                        ),
                                        dropbox_role => {
                                            return dropbox_role.precept;
                                        }
                                    )
                                );
                                precept = precept ? precept : "";

                                return _.filter(
                                    [username, first_name, last_name, `${first_name} ${last_name}`, precept],
                                    search => {
                                        return _.includes(
                                            (search).toUpperCase(),
                                            (group_search).toUpperCase()
                                        );
                                    }
                                ).length > 0;
                            }
                        ).length > 0;
                    }
                ),
                submission => {
                    const submission_memberships =_.filter(
                        memberships,
                        membership => {
                            return membership.submission.id === submission.id;
                        }
                    );
                    return (
                        <CardBlock className="submission" key={`submission_${submission.id}`}>
                            <div title="Submission ID">{submission.id}</div>
                            {
                                _.map(
                                    submission_memberships,
                                    membership => {
                                        const user = users[membership.user.id],
                                            precept = _.find(
                                                _.map(
                                                    _.filter(
                                                        roles,
                                                        dropbox_role => {
                                                            return dropbox_role.role === STUDENT && dropbox_role.user.id === user.id;
                                                        }
                                                    ),
                                                    dropbox_role => {
                                                        return dropbox_role.precept;
                                                    }
                                                )
                                            )
                                        ;

                                        return (
                                            <Link
                                                className={`user btn btn-sm btn-${(membership.confirmed) ? "success" : "warning"}`}
                                                to={`/dropbox/${assignment.dropbox.id}/users/${user.id}`}
                                                title={`Submission Group Member (${(!membership.confirmed) ? "Has Not Yet " : ""}Confirmed)`}
                                                key={`unassigned_users_${user.id}`}
                                            >
                                                {user.first_name} {user.last_name} {`<${user.username}>`}
                                                {precept ? ` - ${precept}` : ""}
                                            </Link>
                                        );
                                    }
                                )
                            }
                            <label className="help-text group-size">
                                Group size:{submission_memberships.length}
                            </label>
                        </CardBlock>
                    );
                }
            )
        : null;
    }

    render() {
        const isLoading = this.props.request.sendingRequest;

        if (isLoading) {
            return (
                <Spinner
                    spinnerName="wandering-cubes"
                    className="spinner"
                    noFadeIn
                />
            );
        }

        const { assignmentName, dropboxName } = this.props.params,
            assignment = this.getAssignment(),
            users = getMappedKeyEntities(this.props.users),
            memberships = getMappedKeyEntities(this.props.memberships),
            submissions = getMappedKeyEntities(this.props.submissions, 'id', 'string'),
            { group_search } = this.state,
            unassigned_users = _.filter(
                users,
                user => {
                    return _.filter(
                        memberships,
                        membership => {
                            return membership.user.id === user.id;
                        }
                    ).length === 0;
                }
            ),
            single_person_groups = _.filter(
                submissions,
                submission => {
                    return _.filter(
                        memberships,
                        membership => {
                            return membership.submission.id === submission.id;
                        }
                    ).length === 1;
                }
            ),
            multiple_person_groups = _.filter(
                submissions,
                submission => {
                    return _.filter(
                        memberships,
                        membership => {
                            return membership.submission.id === submission.id;
                        }
                    ).length > 1;
                }
            ),
            unconfirmed_memberships = _.filter(
                memberships,
                membership => {
                    return !membership.confirmed;
                }
            )
        ;

        // convert group members into csv format, perhaps should do this on as neeeded basis
        let csvData =[['group_id', 'netids']];

        _.map(
            submissions,
            submission => {
                const submission_memberships =_.filter(
                    memberships,
                    membership => {
                        return membership.submission.id === submission.id
                            && membership.confirmed === true
                        ;
                    }
                );

                let tmp_row = [submission.id],
                    group_members = []
                ;

                _.map(
                    submission_memberships,
                    membership => {
                        group_members.push(membership.user.username);
                    }
                );

                tmp_row.push(group_members);
                csvData.push(tmp_row);
            }
        );

        return assignment
        ?
            (
                <div className="col-md-12">
                    <div className={"action-links"}>
                        <NavBar
                            className="navbar navbar-toggleable-md navbar-light bg-faded fixed-top navbar-sub"
                            display
                        >
                            <NavLink
                                to={`/${dropboxName}/${assignmentName}/edit`}
                                className="btn btn-outline-primary btn-md"
                                side="left"
                                display
                                key="exit"
                            >
                                Exit To Assignment <i className={"fa fa-chevron-circle-left"} />
                            </NavLink>
                            <NavLink
                                className="nav-item"
                                to={null}
                                side="right"
                                display
                                key="csv_export"
                                noLink
                            >
                                <CSVLink
                                    data={csvData}
                                    separator="|"
                                    filename={`${dropboxName}_${assignmentName}_groups.csv`}
                                >
                                    <button className="btn btn-md btn-success" type="button">
                                        CSV export <i className="fa fa-download" aria-hidden="true"/>
                                    </button>
                                </CSVLink>
                            </NavLink>
                        </NavBar>
                    </div>
                    <h3>{dropboxName}</h3>
                    <div className="card-block">
                        <div className="card">
                            <div className="card-header bg-primary">
                                {assignment.name} - Groups
                            </div>
                            <div className="card-block">
                                <div className="row">
                                    <div className="col-md-8">
                                        <input
                                            className="form-control group-search"
                                            onChange={this.handleGroupSearchChange}
                                            placeholder="Filter: Name, NetID, or Precept"
                                            type="text"
                                            value={group_search}
                                        />
                                    </div>
                                </div>
                                <hr/>
                                <div className="row">
                                    <div className="col-md-9">
                                        <h5>Groups</h5>
                                        <span className="mr-2">
                                            <i title="Multiple Person Groups" className="fa fa-users assignment-green" aria-hidden="true"/> {multiple_person_groups.length}
                                        </span>
                                        <span className="mr-2">
                                            <i title="Single Person Groups" className="fa fa-user assignment-green" aria-hidden="true"/> {single_person_groups.length}
                                        </span>
                                        <span className="mr-2">
                                            <i title="Users who have not confirmed" className="fa fa-user assignment-yellow" aria-hidden="true"/> {unconfirmed_memberships.length}
                                        </span>
                                        {this.renderSubmissions()}
                                    </div>
                                    <div className="col-md-3 user-buttons">
                                        <h5>Unassigned Students ({unassigned_users.length})</h5>
                                        {
                                            unassigned_users.map((user) => {
                                                return (
                                                    <Link
                                                        className="btn btn-sm btn-info"
                                                        title={`${user.first_name} ${user.last_name}`}
                                                        to={`/dropbox/${assignment.dropbox.id}/users/${user.id}`}
                                                        key={`unassigned_users_${user.id}`}
                                                    >
                                                        {user.username}
                                                    </Link>
                                                );
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        : null;
    }
}

InstructorAssignmentGroupsPage.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dropboxes: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    request: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    users: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    const { auth, assignment, assignments, dropboxes, memberships, request, roles, roles_self, submissions, users } = state;

    return { auth, assignment, assignments, dropboxes, memberships, request, roles, roles_self, submissions, users };
}

export default connect(mapStateToProps)(withRouter(InstructorAssignmentGroupsPage));


/** WEBPACK FOOTER **
 ** ./src/containers/InstructorAssignmentGroupsPage.js
 **/